import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

export const passageBrowserBackGuard: CanDeactivateFn<any> = (
  component: any,
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  nextState: RouterStateSnapshot
) => {
  // NOTE: This seems like a hack and it would be nice if we  could
  //  reorganize our routes some way to check this better.  We also
  //  want to disable the back button completely for students in the future
  //  so we might be able to rethink this then.

  // Don't allow navigation if our passage is undefined and we are
  //  coming from passagesReadAndListen and going to one of the sub
  //  tasks passages tasks.
  let navigationExtras = inject(Router).currentNavigation()?.extras;
  if ((nextState.url === '/findThePictureIntervention' || nextState.url === '/answerTheQuestionIntervention')
      && !navigationExtras?.state?.passage && state.url === '/passagesReadAndListen')
  {
    return false;
  }

  return true;
}
